import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { SectionTemplateComponent } from '@templates/section-template/section-template.component';
import { IHome_PopularResponse } from '@shared/constants/models.const';
import { NgClass } from '@angular/common';
import { RemoveHtmlPipe } from '@shared/pipes/remove-html.pipe';
import { TranslateModule } from '@ngx-translate/core';
import { HelperService } from '../../../../services/helper.service';
import { E_DATE_FORMAT } from '@shared/constants/enums.const';

@Component({
  selector: 'app-popular-section',
  imports: [
    SectionTemplateComponent,
    NgClass,
    RemoveHtmlPipe,
    TranslateModule,

  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './popular-section.component.html',
  styleUrl: './popular-section.component.scss',
})
export class PopularSectionComponent {
  data = input<IHome_PopularResponse[]>();

  protected readonly E_DATE_FORMAT = E_DATE_FORMAT;

  getUrl(item: IHome_PopularResponse): string {
    return this.HELPER.getUrl(item.sourceUrl);
  }

  constructor(
    public HELPER: HelperService,
  ) {
  }
}
